import IContact from '../../interfaces/contact/contact';

export const getContactDataModel = (data: IContact, staffEmail: string) => {
	const model = {
		mission: data.mission,
		name: data.name,
		ssn: data.ssn,
		email: data.email,
		phone: data.phone,
		trackingnumber: data.trackingnumber,
		residence: data.residence,
		zip: data.zip,
		staffEmail: staffEmail,
		comments: data.comments,
	};

	return model;
};
